module.exports = __webpack_public_path__ + "img/c7a1a16.png";